"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpgradeButton = exports.RetrofitAccounts = exports.OnMailAccount = void 0;
exports["default"] = AccountProvidersModal;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Button = _interopRequireDefault(require("../Button"));
function AccountProvidersModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    disableBackdropClick: true,
    open: open,
    maxWidth: "lg",
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right m-4"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClose,
    className: "text-gray-light hover:opacity-75"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "large"
  }))), _react["default"].Children.map(children, function (node, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "mb-4 last:mb-10"
    }, node);
  })));
}
var OnMailAccount = exports.OnMailAccount = function OnMailAccount(_ref2) {
  var children = _ref2.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "text-2xl text-dark font-bold py-4"
  }, t('multipleSession.addAccount.onmail')), /*#__PURE__*/_react["default"].createElement("div", null, children));
};
var RetrofitAccounts = exports.RetrofitAccounts = function RetrofitAccounts(_ref3) {
  var children = _ref3.children,
    message = _ref3.message;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "text-2xl text-dark font-bold py-4"
  }, t('retrofit.oauthList.header', {
    count: 0
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('max-w-2xl m-auto', {
      'pb-4': !message
    })
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-gray-medium font-light"
  }, t('retrofit.featurePopup.description'))), message && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-gray-medium text-center mt-1 pb-4"
  }, message), /*#__PURE__*/_react["default"].createElement("div", null, children));
};
var UpgradeButton = exports.UpgradeButton = function UpgradeButton(_ref4) {
  var onClick = _ref4.onClick;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "!px-10 mb-4",
    onClick: onClick
  }, t('button.upgradeToImport'));
};
//# sourceMappingURL=index.js.map